import styled, { css } from 'styled-components';

export const font = css`
  overflow: hidden;
  max-width: 100%;
  font-size: 15px;
  font-weight: 400;
`;

export const ChartCell = styled.div<{ $isfirst?: number; $islast?: number }>`
  position: relative;
  width: 100%;
  height: 100%;
  padding-right: 5px;
  ${({ $isfirst }) => $isfirst && 'border-left: 1px solid #e0e0e0;'};
  ${({ $islast }) => $islast && 'border-right: 1px solid #e0e0e0;'};
`;

export const ChartCellFull = styled.div<{ $isfirst?: number; $islast?: number }>`
  position: relative;
  width: 100%;
  height: 100%;
  color: black;
  ${({ $isfirst }) => $isfirst && 'border-left: 1px solid #e0e0e0;'};
  ${({ $islast }) => $islast && 'border-right: 1px solid #e0e0e0;'};
`;

export const ChartCellWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 9px !important;
  padding-right: 5px;
  ${font}
`;

export const ChartText = styled.div`
  position: absolute;
  z-index: 2;
  top: 5px;
  left: 0px;
  ${font}
  width: 100%;
  height: 100%;
  letter-spacing: -0.3px;
`;

export const Text = styled('div')`
  position: absolute;
  z-index: 2;
  top: 5px;
  left: 0px;
  text-align: center;
  letter-spacing: -0.3px;
  font-size: 13px;
  width: 100%;
  height: 100%;
  ${font}
`;

export const ChartBg = styled('div').attrs<{ $background: string; $opacity: number }>(({ $background, $opacity }) => ({
  style: {
    background: $background || 'var(--table-cellrenderer-chart-text-pos-neg-color)',
    opacity: $opacity,
  },
}))<{
  $background: string;
  $opacity: number;
}>`
  position: absolute;
  z-index: 0;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`;
